import { Button } from './Button';
import { Container } from './Container';
import { Home } from './Home';
import { NotFound } from './NotFound';
import { Login } from './Login';
import { NewAccount } from './NewAccount';
import { PrivateRoute } from './PrivateRoute';
import { PasswordForgot } from './PasswordForgot';
import { PopupContent } from './PopupContent';
import { EditProfile } from './EditProfile';
import { DashboardMain } from './DashboardMain/DashboardMain';
import { DashboardEmpty } from './DashboardMain/DashboardEmpty';
import { DashboardFreelancerMain } from './DashboardFreelancerMain';
import { ProjectBrief } from './ProjectBrief';
import { References } from './References';
import { Deadline } from './Deadline';
import { Loader } from './Loader';
import { OnboardingStep } from './OnboardingStep';
import { OnboardingCard } from './OnboardingCard';
import { OnboardingStepWizard } from './OnboardingStepWizard';
import { OnboardingMultiContent } from './OnboardingMultiContent';
import {
  ManagedPopup,
  MarketplacePopup,
  ContactPopup,
  PortfolioPopup,
  VacationPopup,
  ContactInformationPopup,
} from './Popup';
import { UnsubmittedProjectCard, ActiveCard } from './DashboardCard/';
import FreelancerOnboardingStep from './FreelancerOnboardingStep';
import NotificationPagination from './NotificationList/NotificationPagination';
import ScrollToTop from './ScrollToTop/ScrollToTop';
import FreeCommentForm from './FreeCommentForm';

export {
  Button,
  Login,
  NewAccount,
  Container,
  Home,
  NotFound,
  PrivateRoute,
  PasswordForgot,
  DashboardMain,
  DashboardEmpty,
  DashboardFreelancerMain,
  PopupContent,
  Loader,
  OnboardingStep,
  OnboardingCard,
  OnboardingStepWizard,
  OnboardingMultiContent,
  EditProfile,
  ProjectBrief,
  References,
  Deadline,
  ManagedPopup,
  MarketplacePopup,
  ContactPopup,
  UnsubmittedProjectCard,
  ActiveCard,
  PortfolioPopup,
  FreelancerOnboardingStep,
  VacationPopup,
  NotificationPagination,
  ContactInformationPopup,
  ScrollToTop,
  FreeCommentForm,
};



// WEBPACK FOOTER //
// ./src/components/index.js